import { Pipe, PipeTransform } from '@angular/core';
import { OrderReturnJustification } from '../../models';

@Pipe({
  standalone: false,
  name: 'orderReturnJustification',
})
export class OrderReturnJustificationPipe implements PipeTransform {
  transform(justification: OrderReturnJustification | string): string {
    switch (justification) {
      case OrderReturnJustification.STOCK_BURST:
        return 'Furo de estoque';
      case OrderReturnJustification.INVALID_QMV:
        return 'QMV inválido';
      case OrderReturnJustification.OUT_OF_STOCK:
        return 'Quebra de Estoque';
      case OrderReturnJustification.PURCHASE_REGRET:
        return 'Me arrependi da compra';
      case OrderReturnJustification.NO_SYSTEM:
        return 'Sem sistema';
      case OrderReturnJustification.RESEND:
        return 'Reenvio';
      case OrderReturnJustification.SIMILAR_ITEM:
        return 'Item similar';
      case OrderReturnJustification.LOGISTICS_OPTIMIZATION:
        return 'Otimização logística';
      case OrderReturnJustification.DEFECTIVE_PRODUCT:
        return 'Produto com defeito';
      case OrderReturnJustification.WARRANTY:
        return 'Garantia';
      case OrderReturnJustification.PRODUCT_DIFFERENT:
        return 'Produto diferente do que comprei';
      case OrderReturnJustification.PRODUCT_INCOMPLETE_OR_MISSING_PARTS:
        return 'Produto incompleto ou faltando peças';
      case OrderReturnJustification.APPLICATION_ERROR:
        return 'Erro de aplicação';
      case OrderReturnJustification.ORDER_ARRIVED_LATE:
        return 'Pedido chegou com atraso';
      case OrderReturnJustification.ORDER_NOT_DELIVERED:
        return 'Pedido não foi entregue';
      case OrderReturnJustification.MISSING_ITEM_FROM_ORDER:
        return 'Faltou produto no pedido';
      case OrderReturnJustification.NO_LONGER_NEED_PRODUCT:
        return 'Não preciso mais do produto';
      case OrderReturnJustification.COMMERCIAL_REQUEST:
        return 'Solicitação comercial';
      case OrderReturnJustification.PRICE_DIFFERENCE:
        return 'Diferença de preço';
      case OrderReturnJustification.ANOMALOUS_MARGIN:
        return 'Margem Anômala';
      default:
        return justification ? justification : 'N/A';
    }
  }
}
